import { render, staticRenderFns } from "./GlitchLight.vue?vue&type=template&id=2d2b6f61"
import script from "./GlitchLight.vue?vue&type=script&lang=js"
export * from "./GlitchLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports